import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import crossIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
import chainLinkIcon from '../../../../../_metronic/assets/images/svg/data-room/chain-link-blue-icon.svg'
import fileUploadIcon from '../../../../../_metronic/assets/images/svg/data-room/upload-file.svg'
import { useMoveToFolderData } from '../../core/FileToFolderAuth'
import { ToolTipUIForModal } from '../../../widgets/components/UI/ToolTipUIForModal'

export const UploadDrawer: FC = () => {
  const { formatMessage } = useIntl()
  const { showDrawer, setShowDrawer, setShowOptionsDrawer, setAddUrlDrawer, setAddUploadDrawer } =
    useMoveToFolderData()
  return (
    <div
      id='kt_upload'
      className={`${showDrawer ? 'bg-body drawer drawer-on drawer-end' : 'bg-body drawer drawer-end'
        }`}
      data-kt-drawer='true'
      data-kt-drawer-name='activities'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'312px', 'md': '660px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_upload_toggle'
      data-kt-drawer-close='#kt_upload_close'
    >
      <div className='upload-drawer-wrapper card shadow-none rounded-0 w-100'>
        <div
          className='drawer-header d-flex flex-row align-items-center justify-content-between flex-wrap  '
          id='kt_upload_header'
        >
          <div className='d-flex flex-row align-items-center  '>
            <button
              type='button'
              className='btn p-0 btn-active-light-primary me-4 '
              onClick={() => {
                setShowDrawer(false)
              }}
            >
              <img src={crossIcon} alt=''></img>
            </button>

            <div className='d-flex flex-row align-items-center '>
              <h3 className='drawer-head-title  mb-0 me-4 text-dark'>
                {formatMessage({ id: 'Upload Files' })}
              </h3>
              <ToolTipUIForModal
                tooltipText={formatMessage({
                  id: 'Please upload the file.',
                })}
              />
            </div>
          </div>
        </div>
        <div className='upload-drawer-body px-5 py-4 p-md-7 position-relative' id='kt_upload_body'>
          <div
            id='kt_upload_scroll'
            className='w-100 d-flex flex-column align-items-center h-auto mt-2 activity-container-n overflow-visible'
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_upload_body'
            data-kt-scroll-dependencies='#kt_upload_header, #kt_upload_footer'
            data-kt-scroll-offset='5px'
          >
            <div className=' upload-tile-grid'>
              <div
                className='tile cursor-pointer'
                onClick={() => {
                  setShowOptionsDrawer(true)
                  setAddUploadDrawer(true)
                }}
              >
                <img src={fileUploadIcon} alt=''></img>
                <h6 className='text-dark'> {formatMessage({ id: 'Upload Files' })}</h6>
                <p className='mb-0 text-dark'>
                  {formatMessage({
                    id: 'You can upload files directly from your device, or alternatively use cloud storage services like Google drive',
                  })}
                </p>
              </div>
              <div
                className='tile cursor-pointer'
                onClick={() => {
                  setShowOptionsDrawer(true)
                  setAddUrlDrawer(true)
                }}
              >
                <img src={chainLinkIcon} alt=''></img>
                <h6 className='text-dark'>{formatMessage({ id: 'Add URL' })}</h6>
                <p className='text-dark'>
                  {formatMessage({
                    id: 'Add links to external websites or cloud storage services like Google drive',
                  })}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* begin::Footer */}
        <div className='drawer-footer d-flex justify-content-end ' id='kt_footer'>
          <button
            className='btn bg-light text-muted flex-grow-1 flex-md-grow-0'
            onClick={() => {
              setShowDrawer(false)
            }}
          >
            {formatMessage({ id: 'Cancel' })}
          </button>
        </div>
        {/* end::Footer */}
      </div>
    </div>
  )
}
